<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i :class="rule.id == null ? 'bi bi-plus-lg' : 'bi bi-pencil'"></i>
        {{ rule.id == null ? 'Nueva regla de precio' : 'Editar regla de precio' }}
      </h6>
      <button v-if="rule.id != null" type="button" class="form-card__btn" @click="resetForm()">
        <i class="bi bi-plus-lg"></i>
        Nueva
      </button>
    </div>

    <div class="form-card__body">
      <form @submit.prevent="saveRule">
        <div class="form-card__field">
          <label class="form-card__label" for="rule-product">Producto</label>
          <select id="rule-product" v-model="rule.product_id" class="form-control">
            <option :value="null" disabled>Seleccioná un producto</option>
            <option v-for="product in products" :key="product.id" :value="product.id">
              {{ product.name }}
            </option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="rule-fromqty">Desde cantidad</label>
          <input id="rule-fromqty" v-model="rule.fromqty" type="text" class="form-control" placeholder="Ej: 1">
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="rule-toqty">Hasta cantidad</label>
          <input id="rule-toqty" v-model="rule.toqty" type="text" class="form-control" placeholder="Ej: 10">
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="rule-pricelist">Lista de precio</label>
          <select id="rule-pricelist" v-model="rule.pricelist_id" class="form-control">
            <option :value="null" disabled>Seleccioná una lista</option>
            <option v-for="priceList in priceLists" :key="priceList.id" :value="priceList.id">
              {{ priceList.name }}
            </option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="rule-price">Precio</label>
          <input id="rule-price" v-model="rule.price" type="text" class="form-control" placeholder="0.00">
        </div>
      </form>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isSaving" @click="saveRule">
        <i class="bi bi-check-lg"></i>
        {{ rule.id ? 'Modificar regla' : 'Agregar regla' }}
      </button>
    </div>
  </div>
</template>

<script>
const emptyRule = () => ({
  id: null,
  product_id: null,
  fromqty: null,
  toqty: null,
  pricelist_id: null,
  price: null,
});

export default {
  props: {
    ruleId: { type: Number, default: null },
    products: { type: Array, default: () => [] },
    priceLists: { type: Array, default: () => [] },
  },
  data() {
    return {
      isSaving: false,
      rule: emptyRule(),
    };
  },
  watch: {
    ruleId(id) {
      if (id != null) this.getRule(id);
      else this.resetForm();
    },
  },
  methods: {
    saveRule() {
      if (this.isSaving) return;
      this.isSaving = true;
      const url = this.rule.id != null
        ? `/api/configs/promo/edit/${this.rule.id}`
        : '/api/configs/promo/add';
      this.$http.post(url, this.rule)
        .then(() => {
          this.resetForm();
          this.$emit('saved');
        })
        .catch(() => {})
        .then(() => { this.isSaving = false; });
    },
    getRule(id) {
      this.$http.get(`/api/configs/promo/getRule/${id}`).then((response) => {
        this.rule = response.data.data;
      });
    },
    resetForm() {
      this.rule = emptyRule();
      this.$emit('reset-id');
    },
  },
};
</script>